import NewRateCardModal, { NewRateCardModalProps } from './NewRateCardModal';

export type { NewRateCardModalProps };
export default NewRateCardModal;
